import axios from "axios";
import {
  CREATE_ORDER_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_HISTORY_FAILURE,
  GET_ORDER_HISTORY_REQUEST,
  GET_ORDER_HISTORY_SUCCESS,
} from "./ActionType";
import api, { API_BASE_URL } from "../../../config/api";


export const createOrder = (reqData) => async (dispatch) => {
  console.log("req data ", reqData);
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${reqData.jwt}`,
      },
    };

    const { data } = await api.post(
      `${API_BASE_URL}/api/orders/`,
      {
        address: reqData.address,
        discountCode: reqData.discountCode,
        coupenValue: reqData.coupenValue,
        DeliveryCharges: reqData.DeliveryCharges
      },
      config
    );
    console.log("checkout-order",{data})
    localStorage.setItem("orderlist",JSON.stringify(data))
    dispatch({type:GET_ORDER_HISTORY_SUCCESS,payload:data})
    reqData?.navigate({ search: `step=3` });
    // if (data?.success) {
      
    //   reqData.navigate(`/payment/${data?._id}`,{ state: { data: reqData?.response,isPayLater:reqData?.isPaymentLater } })
    // }
    console.log("created order - ", data);
    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log("catch error : ", error);
    dispatch({
      type: CREATE_ORDER_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
export const phonePayPayment=async(reqData,jwt)=>{
  try{
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };
    const res= await api.post(`/api/payments/phonepe`,reqData,config)
    console.log("api-res=>>",res.data)
    localStorage.removeItem("localCartDetails");
    localStorage.removeItem("localCart");
    localStorage.removeItem("localCartAddress");
    localStorage.removeItem("coupenValue");
    localStorage.removeItem("discountCode");
    return res.data
  }
  catch(error){
    console.log(error)
  }
}
export const getOrderById = (orderId) => async (dispatch) => {
  console.log("get order req ", orderId);
  try {
    dispatch({ type: GET_ORDER_BY_ID_REQUEST });

    const { data } = await api.get(
      `/api/orders/${orderId}`,
      
    );
    console.log("order by id ", data);
    dispatch({
      type: GET_ORDER_BY_ID_SUCCESS,
      payload: data,
    });
    // dispatch(updatePayment(data));
  } catch (error) {
    console.log("catch ",error)
    dispatch({
      type: GET_ORDER_BY_ID_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getOrderHistory = (reqData) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ORDER_HISTORY_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${reqData.jwt}`,
      },
    };

    const { data } = await api.get(`/api/orders/user?orderStatus=${reqData?.status}`,config);
    console.log("order history -------- ", data);
    dispatch({
      type: GET_ORDER_HISTORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ORDER_HISTORY_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
